import { useNavigate, useParams } from '@tanstack/react-router'

export const useDocumentList = () => {
  const navigate = useNavigate()
  const { jobId } = useParams({ from: '/process-document/review/$jobId' })

  const handleClickDocumentItem = (taskId: number) => {
    void navigate({ to: '/process-document/review/$jobId', params: { jobId }, search: { taskId } })
  }

  return { handleClickDocumentItem }
}
